// @flow
import React from "react";

import { connect } from "react-redux";

import { Translate, withI18n } from "@quantum/i18n";

import { compose } from "ramda";

import SelectInput from "../../../comum/SelectInput";
import type { Id, TaxaDeAdministracao } from "../../../../model";
import {
  type ActionCreator,
  selecionarTaxaDeAdministracao,
  getTaxasDeAdministracao,
  getTaxaDeAdministracaoSelecionada,
} from "../../../../state";

type Prop = {
  listaTaxaDeAdministracao: Array<TaxaDeAdministracao>,
  taxaDeAdministracaoSelecionada: Id,
  selecionarTaxaDeAdministracao: ActionCreator,
  incluirTaxaEfetiva: boolean,
};

function SelecaoTaxaDeAdmnistracao({
  listaTaxaDeAdministracao,
  taxaDeAdministracaoSelecionada,
  selecionarTaxaDeAdministracao,
  incluirTaxaEfetiva = false,
}: Prop) {
  function handleTaxaDeAdministracaoSelecionada(taxaDeAdministracao) {
    selecionarTaxaDeAdministracao(taxaDeAdministracao);
  }

  return (
    <div className="ConfiguracaoMedida">
      <label className="ConfiguracaoMedida__label">
        <Translate>maiusculas.taxaAdministracao</Translate>
      </label>
      <SelectInput
        className="ConfiguracaoMedida__input-select"
        value={taxaDeAdministracaoSelecionada}
        options={listaTaxaDeAdministracao}
        onChange={handleTaxaDeAdministracaoSelecionada}
        multiple={false}
        size={2}
        campoDescricao={"traducao"}
      />
    </div>
  );
}

export default compose(
  withI18n,
  connect(
    (state, { translate, incluirTaxaEfetiva }) => ({
      listaTaxaDeAdministracao: getTaxasDeAdministracao(
        state,
        incluirTaxaEfetiva
      ).map(taxa => ({
        ...taxa,
        traducao: translate(taxa.chaveTraducao),
      })),
      taxaDeAdministracaoSelecionada: getTaxaDeAdministracaoSelecionada(state),
    }),
    { selecionarTaxaDeAdministracao }
  )
)(SelecaoTaxaDeAdmnistracao);
